import React, {useState, useMemo, useEffect} from 'react';

import {useFormStore} from '../../../Stores/form';

import './index.scss'

export default function Subtitle(props) {
    const {disabled, field, isEditMode} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const className = useMemo(() => {
        return 'Subtitle'
        + (isDisabled ? ' disabled' : '')
        + (showErrorText ? ' error' : '')
    }, [isDisabled, showErrorText, field]);

    return (<div className={className}>
            {field.placeholder}
            <div className="information">{field.information}</div>
        </div>)
}
